export const ENDPOINT_PROJECTS =  "projects/";
export const ENDPOINT_STATIONS =  "stations/";
export const ENDPOINT_ORGANIZATIONS =  "organizations/";
export const ENDPOINT_ONBOARDING_SERVICES =  "onboarding-services/";
export const ENDPOINT_STATION_TYPES =  "station-types/";
export const ENDPOINT_STATION_ONBOARDING = "onboarding";